<!---------------------------------new ui---------------------------------------------------->
<div  style="min-height: 500.44px;">

    <section class="content-header ">
    <div class="container-fluid ">
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Product Complaints</h1>
    </div>
    
    </div>
    </div>
    </section>
    
    <section class="content">
    
    <div class="card">
    <div class="card-header">
    
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
        <cdk-virtual-scroll-viewport itemSize="50" class="virtual-viewport">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 40%">
    Product Name
    </th>

    <th style="width: 12%">
    Complaint
    </th>
    
     
    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *cdkVirtualFor="let c of output">
    <td>
    <a>
    {{c.product_name}}
    </a>
    </td>
    
    <td>
     {{c.product_complaint_or_out_of_stock}}
    </td>
    
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm">
    <i class="fas fa-folder">
    </i>
    View
    </a>
    <a class="btn btn-info btn-sm left">
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
    
    <a class="btn btn-danger btn-sm left">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    
    </td>
    </tr>
    

    </tbody>
    </table>
</cdk-virtual-scroll-viewport>
    </div>
    
    </div>
    
    </section>
    